import { APP_STATUSES } from "utils/AppStatusContext"

export function getBackButtonText(from: APP_STATUSES | undefined) {
    switch (from) {
        case APP_STATUSES.profile:
            return "К профилю"
        case APP_STATUSES.search_page:
            return "К психологам"
        case APP_STATUSES.survey_results:
            return "К подборке"
        default:
            return "Назад"
    }
}
